<template>
  <detailTemplate :classCustom="'detail-docs extend-detail'">
    <template #content>
      <div style="overflow: auto;">
        <div
          class="back-icon border-radius__50 clickable flex-row flex__center"
          @click="backListPage()"
        >
          <i class="el-icon-back font-size__large"></i>
        </div>
        <div class="header margin-bottom-10">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold"
          >
            Lịch tuần lãnh đạo
          </div>
        </div>

        <!--        <FullCalendar-->
        <!--          class="margin-top-5 lichTuanCalendar"-->
        <!--          locale="vi"-->
        <!--          :firstDay="1"-->
        <!--          :height="height"-->
        <!--          :allDaySlot="false"-->
        <!--          :handleWindowResize="true"-->
        <!--          :resourceLabelText="'Danh sách phòng'"-->
        <!--          :noEventsMessage="'Không có dữ liệu'"-->
        <!--          :plugins="calendarPlugins"-->
        <!--          :defaultView="defaultView"-->
        <!--          :header="header"-->
        <!--          :custom-buttons="customButtons"-->
        <!--          :buttonText="buttonText"-->
        <!--          :events="listRequestAccepted2"-->
        <!--          :eventRender="eventRender"-->
        <!--          ref="calendarRef"-->
        <!--          @eventDestroy="eventDestroy"-->
        <!--        />-->

        <hc-calendar-full-calendar
          :height="height"
          :availableFlows="availableFlows"
        ></hc-calendar-full-calendar>
      </div>
    </template>
  </detailTemplate>
</template>

<script>
  import FullCalendar from "@fullcalendar/vue";
  // import moment from "moment";
  // import Vue from "vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  // import h from "../../../services/h";
  import hanhchinhService from "../../../services/hanhchinhService";
  // import hanhChinhUtils from "../../../services/hanhChinhUtils";
  // import FullCalendarLichtuanRow from "./fullCalendar-lichtuan-row";
  import HcCalendarFullCalendar from "./hc-calendar-full-calendar";

  // const FullCalendarLichtuanRowClass = Vue.extend(FullCalendarLichtuanRow);

  export default {
    name: "dkPhongHop-lichdangky",
    components: {
      HcCalendarFullCalendar,
      VuePerfectScrollbar,
      FullCalendar,
      detailTemplate: () => import("../../common/detail.vue")
    },

    data() {
      return {
        // searchKeyTabSentAndProcessing: "",
        // isDay: null,
        // pageable: {
        //   size: 10,
        //   page: 0,
        //   sort: "createTime,desc"
        // },
        // deptId: null,
        flowCode: "LICH_TUAN",
        availableFlows: [],
        // customButtons: {},
        // calendarPlugins: [listPlugin],
        // defaultView: "listWeek",
        // header: {
        //   left: "prev,today,next",
        //   center: null,
        //   right: "listDay,listWeek"
        // },
        // titleFormat: {
        //   year: "numeric",
        //   month: "2-digit",
        //   day: "2-digit"
        // },
        // views: {
        //   listDay: {},
        //   listWeek: {}
        // },
        // buttonText: {
        //   today: "Hôm nay",
        //   listWeek: "Tuần",
        //   listDay: "Ngày"
        // },
        // listRequestAccepted: [],
        // listRequestAccepted2: [],
        // eventsObj: {},
        height: window.innerHeight - 130,
        // capQuyTrinhButtons: [],
        // selectedCapQuyTrinhButton: null
      };
    },

    created() {
      this.initFlowsAvailable();
    },

    methods: {
      // eventDestroy(e) {
      //   let id = parseInt(e.el.getAttribute("data-vue-id"));
      //   if (this.eventsObj[id]) {
      //     this.eventsObj[id].$destroy(true);
      //   }
      // },

      // reloadPage() {
      //   this.listRequestAccepted = [];
      //   this.pageable.page = 0;
      //   let monday;
      //   let sunday;
      //   monday = moment()
      //     .subtract(1, "months")
      //     .startOf("isoWeek")
      //     .toDate()
      //     .getTime();
      //   sunday = moment()
      //     .add(1, "months")
      //     .endOf("isoWeek")
      //     .toDate()
      //     .getTime();
      //   let pageable = {
      //     size: 1000,
      //     page: this.pageable.page,
      //     sort: this.pageable.sort
      //   };
      //   this.getAcceptedRequests(
      //     monday,
      //     sunday,
      //     this.searchKeyTabProcessed,
      //     this.deptId,
      //     pageable
      //   );
      // },

      initFlowsAvailable() {
        return hanhchinhService.getFlowsAvailable(this.flowCode).then(res => {
          this.availableFlows = res.data.hcFlows;
          // if (this.availableFlows && this.availableFlows.length)
          //   this.deptId = this.availableFlows[0].deptId;
          // this.initCustomButtons();
        });
      },

      // initCustomButtons() {
      //   this.capQuyTrinhButtons = [];
      //   h.each(this.availableFlows, item =>
      //     this.capQuyTrinhButtons.push({
      //       id: item.deptId,
      //       deptId: item.deptId,
      //       label: item.deptName,
      //       type: "deptId"
      //     })
      //   );
      //   this.capQuyTrinhButtons.push({
      //     id: "viewSharedOnlyButton",
      //     deptId: null,
      //     label: "Lịch tuần được chia sẻ",
      //     type: "shareButton"
      //   });
      //   this.selectedCapQuyTrinhButton = h.find(
      //     this.capQuyTrinhButtons,
      //     item => item.id === this.deptId
      //   );
      // },

      backListPage() {
        this.$router.push({
          name: "adminstration-regiscalendarweek"
        });
      },

      // getAcceptedRequests(startDate, endDate, keyword, deptId, pageable) {
      //   return hanhchinhService
      //     .getAcceptedRequestsIncludeCoopDepts(
      //       startDate,
      //       endDate,
      //       keyword,
      //       deptId,
      //       pageable
      //     )
      //     .then(response => {
      //       let items = response.data.hcCaseCalendars;
      //       items.forEach(item => {
      //         this.listRequestAccepted.push(
      //           hanhChinhUtils.convertToHcCaseCalendarAccepted(item)
      //         );
      //       });
      //     });
      // },

      // eventRender(e) {
      //   let data = e.event.extendedProps;
      //   let component = new FullCalendarLichtuanRowClass({
      //     propsData: {
      //       meetingTitle: e.event.title,
      //       meetingPlace: data.meetingPlace,
      //       parentDeptName: data.parentDeptName,
      //       // leaderNames: data.leaderNames,
      //       chairedUnit: data.chairedUnit,
      //       cooperateDeptNames: h.collect(
      //         data.listHcCoopDepts,
      //         item => item.cooperateDeptName
      //       ),
      //       meetingContent: data.meetingContent,
      //       otherInvolved: data.otherInvolved,
      //       caseMasterId: data.caseMasterId,
      //       hcCaseCalendarId: data.hcCaseCalendarId,
      //       groupFilters: this.groupFilters,
      //       isViewShareMode:
      //         this.selectedCapQuyTrinhButton.type === "shareButton",
      //       hcCaseCalendarView: data.hcCaseCalendarView
      //     }
      //   });
      //   component.$mount();
      //   this.eventsObj[component._uid] = component;
      //   //assign created component to our eventObj with uuid as key (to destroy in future)
      //   this.eventsObj[component._uid] = component;
      //   //set data-vue="{id}"
      //   //append our compiled component to .fc-component
      //   e.el.setAttribute("data-vue-id", component._uid);
      //   e.el.lastElementChild.childNodes[0].remove();
      //   e.el.lastElementChild.appendChild(component.$el);
      //   if (data.isDay) {
      //     e.el.firstElementChild.style.borderLeftWidth = "10px";
      //     e.el.firstElementChild.style.borderLeftColor = "#f5c533";
      //     e.el.cells[1].innerHTML = `<div style="color:#f5c533;">Sáng</div>`;
      //   } else {
      //     e.el.firstElementChild.style.borderLeftWidth = "10px";
      //     e.el.firstElementChild.style.borderLeftColor = "#007aff";
      //     e.el.cells[1].innerHTML = `<div style="color:#007aff;">Chiều</div>`;
      //   }
      // }
    }
  };
</script>

<style scoped>
  .lichTuanCalendar .fc-scroller {
    height: 800px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/LichTuan_Calendar.vue